import React, { Fragment } from 'react';

import { css } from '@emotion/react';
import { HStack, Primitive } from '@rtkwlf/fenrir-react';

interface CredentialedScanTargetProps {
  targets: string[];
}

export const CredentialedScanTarget: React.FC<CredentialedScanTargetProps> = ({
  targets,
}) => {
  return (
    <HStack gap="xsmall" wrap="wrap">
      {targets.map((tName: string, index: number) => (
        <Fragment key={`${index}-${tName}`}>
          <Primitive.span
            css={css({
              letterSpacing: '0.1em',
            })}
            backgroundColor="widgetTertiary"
            borderRadius="default"
            padding="small"
            fontSize="small"
          >
            {tName}
          </Primitive.span>
        </Fragment>
      ))}
    </HStack>
  );
};
